/* unplugin-vue-components disabled */import script from "./NianJing.vue?vue&type=script&setup=true&lang=ts"
export * from "./NianJing.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__